import React from 'react';

/**
 * Small status pill. Ported from
 * D:\campaigning-system\src\components\ui\StatusPill.tsx (types stripped,
 * cos-* tokens). Falls back to the neutral "draft" style for unknown statuses.
 */
const STYLES = {
  running: { bg: 'bg-cos-teal-faint', text: 'text-cos-teal-deep', dot: 'bg-cos-teal', label: 'Running' },
  scheduled: { bg: 'bg-cos-beige-light', text: 'text-cos-beige-ink', dot: 'bg-cos-beige-dark', label: 'Scheduled' },
  draft: { bg: 'bg-[#F0F0EC]', text: 'text-cos-ink-secondary', dot: 'bg-cos-ink-muted', label: 'Draft' },
  completed: { bg: 'bg-[#DCEDE7]', text: 'text-[#23745F]', dot: 'bg-[#23745F]', label: 'Completed' },
  failed: { bg: 'bg-cos-status-coral-bg', text: 'text-cos-status-coral', dot: 'bg-cos-status-coral', label: 'Failed' },
  approved: { bg: 'bg-cos-teal-faint', text: 'text-cos-teal-deep', dot: 'bg-cos-teal', label: 'Approved' },
  pending: { bg: 'bg-cos-status-amber-bg', text: 'text-cos-status-amber', dot: 'bg-cos-status-amber', label: 'Pending' },
  risk: { bg: 'bg-cos-status-coral-bg', text: 'text-cos-status-coral', dot: 'bg-cos-status-coral', label: 'At Risk' },
};

export function StatusPill({ status, label, className = '' }) {
  const s = STYLES[status] || STYLES.draft;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-2xs font-semibold ${s.bg} ${s.text} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {label ?? s.label}
    </span>
  );
}

export default StatusPill;
